import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export interface SpartaxCQState {
  isActive: boolean;
  info?: string;
}

@Injectable({
  providedIn: 'root'
})
export class SpartaxCQStateService {
  private cqStateSubject = new BehaviorSubject<SpartaxCQState>({ isActive: false });
  public cqState$: Observable<SpartaxCQState> = this.cqStateSubject.asObservable();

  setCQState(isActive: boolean, info?: string): void {
    this.cqStateSubject.next({ isActive, info });
  }

  getCQState(): SpartaxCQState {
    return this.cqStateSubject.value;
  }
}